/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneFrontCoverstory from 'base/components/standalone/FrontCoverstory';

export const DynamicStandaloneFrontCoverstory = StandaloneFrontCoverstory;
export type DynamicStandaloneFrontCoverstoryProps = PropsFromComponent<typeof StandaloneFrontCoverstory>;

export const DynamicStandaloneFrontCoverstoryWith = (extras: DynamicStandaloneExtras): typeof StandaloneFrontCoverstory => {
    return function DynamicStandaloneFrontCoverstory(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'FrontCoverstory');
        return <StandaloneFrontCoverstory {...mergeProps({ options: { theme } }, props)} />;
    }
}